import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/lib/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AcceptInvite from "@/pages/AcceptInvite";
import ClientPortal from "@/pages/ClientPortal";
import Dashboard from "@/pages/Dashboard";
import Clients from "@/pages/Clients";
import ClientDetail from "@/pages/ClientDetail";
import PaymentOptions from "@/pages/PaymentOptions";
import ReminderRules from "@/pages/ReminderRules";
import Reminders from "@/pages/Reminders";
import Team from "@/pages/Team";
import VerifyQueue from "@/pages/VerifyQueue";
import AgeingReport from "@/pages/AgeingReport";
import SmsTemplates from "@/pages/SmsTemplates";
import WhatsAppInbox from "@/pages/WhatsAppInbox";
import PendingApproval from "@/pages/PendingApproval";
import PlatformWorkspaces from "@/pages/PlatformWorkspaces";
import PlatformUsers from "@/pages/PlatformUsers";
import ChangePassword from "@/pages/ChangePassword";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Settings from "@/pages/Settings";
import "@/App.css";

function App() {
  return (
    <div className="App font-body">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/portal/:token" element={<ClientPortal />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route path="/app" element={<Navigate to="/app/dashboard" replace />} />
              <Route path="/app/dashboard" element={<Dashboard />} />
              <Route path="/app/clients" element={<Clients />} />
              <Route path="/app/clients/:id" element={<ClientDetail />} />
              <Route path="/app/payment-options" element={<PaymentOptions />} />
              <Route path="/app/reminder-rules" element={<ReminderRules />} />
              <Route path="/app/reminders" element={<Reminders />} />
              <Route path="/app/verify" element={<VerifyQueue />} />
              <Route path="/app/reports/ageing" element={<AgeingReport />} />
              <Route path="/app/sms-templates" element={<SmsTemplates />} />
              <Route path="/app/whatsapp" element={<WhatsAppInbox />} />
              <Route path="/app/team" element={<Team />} />
              <Route path="/app/admin/workspaces" element={<PlatformWorkspaces />} />
              <Route path="/app/admin/users" element={<PlatformUsers />} />
              <Route path="/app/change-password" element={<ChangePassword />} />
              <Route path="/app/pending-approval" element={<PendingApproval />} />
              <Route path="/app/settings" element={<Settings />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="bottom-right" richColors closeButton />
      </AuthProvider>
    </div>
  );
}

export default App;
